/* eslint-disable compat/compat */

// @flow

import jsonp from 'jsonp';
import get from 'lodash/get';
import { createHttpClient, getClientStore } from '@fil-global/eiswagen';
import RiskMinder from '@fil-global/fil-lib-riskminder';
import { INACTIVE_RENEW } from '../global/userAuth/constants';
import api from '../constants/apis';

/* istanbul ignore next http://localhost:9876 https://sean-admin-api.cat.myinvestorportal.ca */

const host =
  process.env.NODE_ENV === 'production'
    ? window.host
    : 'https://sean-admin-api.cat.myinvestorportal.ca';

export { host };

const axiosConfig = {
  host,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: 0,
    MFP: JSON.parse(RiskMinder.getMFP()),
    userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
  timeout: 60000,
  withCredentials: true,
  crossOrigin: true,
};

/**
 * Axios Blob Client For finance report from AWS
 */
const axiosBlobConfigForAWS = {
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    MFP: JSON.parse(RiskMinder.getMFP()),
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: 0,
    userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
  timeout: 300000,
  withCredentials: false,
  method: 'get',
  responseType: 'blob',
};

const axiosClient = createHttpClient(axiosConfig);

export const setupHttpClientInterceptor = (callbackFor401: Function, callbackFor500: Function) => {
  axiosClient.interceptors.request.use(config => {
    const { url } = config;
    const dispatch = get(getClientStore(), 'dispatch', () => {});
    const state = get(getClientStore(), 'getState', () => {});
    const language =
      state().global.fccCommon.permission &&
      state().global.fccCommon.permission.userInfo &&
      state().global.fccCommon.permission.userInfo.language;

    const newConfig = { ...config };
    newConfig.headers.language = language;

    const data = new Date();
    if (url !== api.LOGOUT) {
      dispatch({ type: INACTIVE_RENEW, data });
      window.localStorage.setItem('inactiveTiming', data.toString());
    }
    return newConfig;
  });

  axiosClient.interceptors.response.use(
    response => response,
    error => {
      const status = get(error, `response.status`, null);
      const errorData = get(error, 'response.data', { message: 'Unexpected error' });

      if (status === 401) {
        callbackFor401(errorData);
      }

      if (status === 500) {
        callbackFor500();
      }

      if (status === 504) {
        errorData.isTimedOut = true;
      }

      return Promise.reject(errorData);
    }
  );
};

export const jsonpClient = (url: string, callbackName: string): Promise<any> =>
  new Promise((resolve, reject) => {
    jsonp(url, { name: callbackName }, (error, data) => {
      if (!error) {
        resolve(data);
      } else {
        reject(error);
      }
    });
  });

/**
 * Axios Blob Client
 */
const axiosBlobConfig = {
  host,
  method: 'get',
  responseType: 'blob',
  timeout: 10000,
  withCredentials: true,
};

export const axiosBlobClient = createHttpClient(axiosBlobConfig);
axiosBlobClient.interceptors.response.use(
  response => response,
  error => Promise.reject(error) //eslint-disable-line
);

/**
 * Axios Blob Client for Bulkupload download template
 */
const axiosBlobS3Config = {
  method: 'get',
  responseType: 'blob',
  timeout: 10000,
  withCredentials: true,
};

export const axiosBlobS3Client = createHttpClient(axiosBlobS3Config);
axiosBlobClient.interceptors.response.use(
  response => response,
  error => Promise.reject(error) //eslint-disable-line
);

export const axiosBlobAWSClient = createHttpClient(axiosBlobConfigForAWS);
axiosBlobClient.interceptors.response.use(
  response => response,
  error => Promise.reject(error) //eslint-disable-line
);

export default axiosClient;
